import './call-saaed-office.scss';

interface CallSaaedOfficeProps {
  reportCount: number; // 0 or 2+
  language?: 'ar' | 'en' | 'ur';
  onRestart: () => void;
}

export default function CallSaaedOffice({
  reportCount,
  language = 'ar',
  onRestart,
}: CallSaaedOfficeProps) {
  const texts = {
    ar: {
      titleNoReports: 'لم يتم العثور على تقارير',
      titleMultipleReports: 'تم العثور على تقارير متعددة',
      messageNoReports: 'عذراً، لم نتمكن من العثور على أي تقارير مرتبطة بهذه المركبة في النطاق الزمني المحدد.',
      messageMultipleReports: `تم العثور على ${reportCount} تقارير مرتبطة بهذه المركبة. للحصول على المساعدة في تحديد التقرير الصحيح، يرجى الاتصال بمكتب ساعد.`,
      contactTitle: 'تواصل مع ساعد',
      contactMessage: 'للحصول على المساعدة، يرجى الاتصال بمكتب ساعد على:',
      phoneLabel: 'رقم الهاتف',
      phoneNumber: '800-72233',
      phoneSpoken: 'ثمانمائة اثنين اثنين ثلاثة ثلاثة',
      callNow: 'اتصل الآن',
      helpText: 'فريق الدعم متاح لمساعدتك في العثور على رقم تقريرك',
      restart: 'بدء بحث جديد',
    },
    en: {
      titleNoReports: 'No Reports Found',
      titleMultipleReports: 'Multiple Reports Found',
      messageNoReports: 'Sorry, we couldn\'t find any reports associated with this vehicle in the specified date range.',
      messageMultipleReports: `We found ${reportCount} reports associated with this vehicle. To get help identifying the correct report, please contact SAAED office.`,
      contactTitle: 'Contact SAAED',
      contactMessage: 'For assistance, please call SAAED office at:',
      phoneLabel: 'Phone Number',
      phoneNumber: '800-72233',
      phoneSpoken: 'eight hundred, seven two two three three',
      callNow: 'Call Now',
      helpText: 'Support team is available to help you find your report number',
      restart: 'Start New Search',
    },
    ur: {
      titleNoReports: 'کوئی رپورٹ نہیں ملی',
      titleMultipleReports: 'متعدد رپورٹیں ملیں',
      messageNoReports: 'معذرت، مخصوص تاریخ کی حد میں اس گاڑی سے متعلق کوئی رپورٹ نہیں مل سکی۔',
      messageMultipleReports: `اس گاڑی سے متعلق ${reportCount} رپورٹیں ملی ہیں۔ صحیح رپورٹ کی شناخت میں مدد کے لیے براہ کرم SAAED دفتر سے رابطہ کریں۔`,
      contactTitle: 'SAAED سے رابطہ کریں',
      contactMessage: 'مدد کے لیے، براہ کرم SAAED دفتر کو کال کریں:',
      phoneLabel: 'فون نمبر',
      phoneNumber: '800-72233',
      phoneSpoken: 'آٹھ سو، سات دو دو تین تین',
      callNow: 'ابھی کال کریں',
      helpText: 'سپورٹ ٹیم آپ کی رپورٹ نمبر تلاش کرنے میں مدد کے لیے دستیاب ہے',
      restart: 'نئی تلاش شروع کریں',
    },
  };

  const t = texts[language];
  const isNoReports = reportCount === 0;
  const title = isNoReports ? t.titleNoReports : t.titleMultipleReports;
  const message = isNoReports ? t.messageNoReports : t.messageMultipleReports;

  return (
    <div className="call-saaed-container">
      <div className="call-saaed-icon">
        <span className="material-symbols-outlined">
          {isNoReports ? 'search_off' : 'content_copy'}
        </span>
      </div>

      <div className="call-saaed-content">
        <h3>{title}</h3>
        <p className="message">{message}</p>

        <div className="contact-box">
          <div className="contact-header">
            <span className="material-symbols-outlined">support_agent</span>
            <h4>{t.contactTitle}</h4>
          </div>
          <p className="contact-message">{t.contactMessage}</p>
          
          <div className="phone-info">
            <span className="phone-label">{t.phoneLabel}:</span>
            <a href="tel:80072233" className="phone-number">
              {t.phoneNumber}
            </a>
          </div>

          <a href="tel:80072233" className="call-button">
            <span className="material-symbols-outlined">phone</span>
            {t.callNow}
          </a>

          <p className="help-text">{t.helpText}</p>
        </div>
      </div>

      <div className="action-buttons">
        <button className="restart-button" onClick={onRestart}>
          <span className="material-symbols-outlined">refresh</span>
          {t.restart}
        </button>
      </div>
    </div>
  );
}

